









export default {
    props: {
        promptOptionData: {
            instruction: String,
            icon: Array,
            required: true,
        },
    },
    setup() {},
};
